export default {
    name: 'organizacion',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-organizacion',
            component: () => import('@/modules/organizacion/view/Home.vue'),
        },
        {
            path: 'add',
            name: 'add-organizacion',
            component: () => import('@/modules/organizacion/view/Add.vue'),
            props: (route) => {
                return {
                    id: 'new'
                }
            }
        },
        {
            path: ':id',
            name: 'edit-organizacion',
            component: () => import('@/modules/organizacion/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]

}